exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cpd-list-card[data-v-9f4be490]  .v-toolbar__title{font-size:18px;font-weight:500}.cpd-table[data-v-9f4be490]  .v-data-table-header th{font-weight:600}.cpd-table[data-v-9f4be490]  tbody td{font-size:12px;line-height:1.35}", ""]);

// exports
